module.exports = __webpack_public_path__ + "img/126.d42ca139.jpg";